import { fromJS } from 'immutable';
import { calculateResourceSummary } from '@sakari-io/staza-common';

import {
  saveJobRoutine,
  removeJobRoutine,
  saveJobResourcesRoutine,
  removeTasksRoutine,
  fetchJobsRoutine, uploadTasksRoutine
} from '../routines';
import { updateOrAdd, remove } from './helper';

const initialState = fromJS({
  jobs: {},
  job: {
    resources: [],
    exceptions: {},
    start: new Date(),
    end: new Date(),
  },
  loading: false,
  saving: false,
});

const calculateDates = (job) => {
  job.dates = calculateResourceSummary(job);
  return job;
}

export default function (state = initialState, action) {
  // console.log('action', action);
  switch (action.type) {
    case fetchJobsRoutine.REQUEST:
      return state.setIn(['jobs', 'loading'], true);
    case fetchJobsRoutine.SUCCESS:
      return state.set('jobs', fromJS({
        data: action.payload.response.data.map(calculateDates),
        pagination: action.payload.response.pagination
      }));
    case fetchJobsRoutine.FAILURE:
      return state.setIn(['jobs', 'loading'], false);
    // case FETCH_JOB_SUCCESS:
    //   return state.set('job', fromJS(action.job)).set('loading', false);
    // case FETCH_JOB_FAILED:
    //   return state.set('error', action.error).set('loading', false);
    // case SET_TASK_PROFILES:
    //   return state.setIn(['job', 'taskProfiles'], fromJS(action.taskProfiles));
    // case ADD_PREFERRED_ITEM:
    //   return state.updateIn(['job', 'preferredItems'], updateOrAdd(fromJS(action.item))).set('loading', false);
    // case REMOVE_PREFERRED_ITEM:
    //   return state.updateIn(['job', 'preferredItems'], remove(fromJS(action.item)))
    //     .set('loading', false);
    // case SET_PREFERRED_ITEMS :
    //   return state.setIn(['job', 'preferredItems'], fromJS(action.itemTypes));
    // case ADD_TASK_PROFILE:
    //   return state.updateIn(['job', 'taskProfiles'], updateOrAdd(fromJS(action.taskProfile))).set('loading', false);
    // case REMOVE_TASK_PROFILE:
    //   return state.updateIn(['job', 'taskProfiles'], remove(fromJS(action.taskProfile)))
    //     .set('loading', false);
    // case ADD_STAGE:
    //   return state.set('loading', false)
    //     .updateIn(['job', 'stages'], updateOrAdd(fromJS(action.stage)));
    // case REMOVE_STAGE:
    //   return state.updateIn(['job', 'stages'], remove(fromJS(action.stage)));
    case saveJobRoutine.SUCCESS:
      return state
        .updateIn(['jobs', 'data'], updateOrAdd(fromJS(calculateDates(action.payload.response.data))));
    case saveJobRoutine.FAILURE:
      return state.set('error', action.error).set('saving', false);

    case saveJobResourcesRoutine.SUCCESS:
      // const dates = calculateResourceSummary(state.get('job').toJS());
      // const jobId = state.get('job').get('id');
      // return state.updateIn(['jobs'], (jobs) => {
      //   return jobs.map((job) => {
      //     if (job.get('id') === jobId) {
      //       return state.get('job').setIn(['dates'], fromJS(dates));
      //     }
      //
      //     return job;
      //   });
      // });
      return state.updateIn(['jobs', 'data'], (data) => {
        return data.map((job) => {
          console.log('ids', job.get('id'), action.payload.request.id)
          if (job.get('id') === action.payload.request.id) {
            return job.set('resources', fromJS(action.payload.response.data))
              .update((job) => fromJS(calculateDates(job.toJS())));
          }

          return job;
        })
      });

    case removeJobRoutine.SUCCESS:
      console.log('action.payload', action.payload);
      return state.updateIn(['jobs', 'data'], remove(fromJS(action.payload.request)));
    case removeJobRoutine.FAILURE:
      return state.set('error', action.error);
    // case UPLOAD_TASKS_SUCCESS:
    //   console.log('UPLOAD_TASKS_SUCCESS', action);
    //   // console.log()
    //   return state.updateIn(['jobs'], (jobs) => {
    //     return jobs.map((job) => {
    //       if (job.get('id') === action.job.id) {
    //         console.log('action job id dound');
    //         return job.updateIn(['tasks', 'count'], (count = 0) => {
    //           console.log('counts', count, _.keys(action.tasks).length, count + _.keys(action.tasks).length);
    //           return count + _.keys(action.tasks).length;
    //         });
    //       }
    //
    //       return job;
    //     });
    //   }).updateIn(['job', 'tasks', 'count'], (count = 0) => count + _.keys(action.tasks).length);
    case removeTasksRoutine.SUCCESS:
      return state.updateIn(['job', 'tasks', 'count'], (count) => Math.max((count || 0) - action.payload.request.tasks.length, 0))
        .updateIn(['jobs'], (jobs) => {
          const jId = action.payload.request.tasks[0].jobId;
          console.log('jId', jId);
          return jobs.map((job) => {
            console.log('job.getid', job.get('id'));
            if (job.get('id') === jId) {
              return job.setIn(['tasks', 'count'], job.getIn(['tasks', 'count']) - action.payload.request.tasks.length);
            }

            return job;
          });
        });

//TODO review
    case uploadTasksRoutine.SUCCESS:
      return state.updateIn(['jobs','data'], (jobs) => {
        return jobs.map((job) => {
          console.log('action.payload.request.job.id', action.payload.request.job.id, job.get('id'));
          if (job.get('id') === action.payload.request.job.id) {
            return job.updateIn(['tasks', 'count'], (count = 0) => count + action.payload.request.tasks.length);
          }

          return job;
        })
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/jobs.js